<template>
    <div class="col-lg-4 dashboard__box-col">
        <div :class="['box ', color]">
            <h2 class="h h--2">Narzędzia</h2>
            <p>Zdobądź certyfikat i korzystaj z wypożyczalni profesjonalnych narzędzi Geberit.</p>
            <p><router-link :to="{name: 'MyTools'}" class="box__link">&raquo; Wyporzyczone narzędzia</router-link></p>
            <router-link :to="{name: 'Tools'}" class="button button__bottom">
                Zobacz katalog narzędzi &raquo;
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ToolsWidget',
        props: {
            color: {
                default: 'box--dark-blue'
            }
        },
        data () {
            return {

            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/app/home/tools/ToolsWidget.vue